module.exports = __webpack_public_path__ + "img/tencent30.9f2a50c1.svg";